
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import { MixinsCalendarCard } from '@xt/client/mixins'

@Component({
  components: {}
})
export default class CalendarCard extends Mixins(MixinsCalendarCard) {
  @Prop({ default: false }) isExistClasshour!: boolean

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
